<div class="relative flex flex-col h-full max-h-screen-dynamic w-full max-w-screen-dynamic">
    <!-- Header -->
    <div class="flex flex-row justify-between flex-auto items-center sm:items-center border-b">
        <div class="text-2xl leading-6 font-bold px-6 py-4 flex items-center">
            {{ (data.title || 'Pesquisa') | autoTranslate }}
        </div>
        <div class="p-4">
            <button (click)="clear()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Search input -->
    <div class="px-6 py-3 border-b bg-gray-50 dark:bg-transparent">
        <mat-form-field [subscriptSizing]="'dynamic'" class="fuse-mat-dense fuse-mat-rounded w-full sm:w-1/2">
            <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
            <input matInput [autocomplete]="'off'" [placeholder]="'Pesquisar' | autoTranslate" [formControl]="searchInputControl" />
        </mat-form-field>
    </div>

    <!-- Content area with fixed height and scrollable content -->
    <div class="flex-1 overflow-hidden flex flex-col">
        <!-- Loading spinner -->
        <div *ngIf="isLoading" class="flex justify-center items-center py-4">
            <mat-spinner diameter="32"></mat-spinner>
        </div>

        <!-- Table container with scroll -->
        <div class="overflow-auto flex-1">
            <table
                *ngIf="dataSource.data && dataSource.data.length; else noData"
                class="w-full bg-card striped normal-table"
                mat-table
                [dataSource]="dataSource"
                matSort
            >
                <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ data.displayColumns[i]?.name | autoTranslate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="pr-6 font-medium whitespace-nowrap">
                            <ng-container [ngSwitch]="getColumnType(data.displayColumns[i])">
                                <span *ngSwitchCase="'mask'">
                                    {{ getNestedValue(element, column) | mask : data.displayColumns[i]?.mask }}
                                </span>
                                <span *ngSwitchCase="'currency'">
                                    {{ getNestedValue(element, column) | prehoxCurrency }}
                                </span>
                                <span *ngSwitchCase="'decimal'">
                                    {{ getNestedValue(element, column) | number : '1.2-2' }}
                                </span>
                                <span *ngSwitchCase="'date'">
                                    {{ getNestedValue(element, column) | date : 'dd/MM/yyyy' }}
                                </span>
                                <span *ngSwitchCase="'datetime'">
                                    {{ getNestedValue(element, column) | date : 'dd/MM/yyyy HH:mm' }}
                                </span>
                                <span *ngSwitchCase="'boolean'">
                                    {{ getNestedValue(element, column) ? ('Sim' | autoTranslate) : ('Não' | autoTranslate) }}
                                </span>
                                <span *ngSwitchDefault>
                                    {{ getNestedValue(element, column) }}
                                </span>
                            </ng-container>
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                <tr class="order-row cursor-pointer" mat-row *matRowDef="let row; columns: columns" (click)="selecionar(row)"></tr>
            </table>

            <ng-template #noData>
                <div class="p-8 sm:p-16 border-t text-3xl font-semibold tracking-tight text-center" autoTranslate>Não há dados!</div>
            </ng-template>
        </div>

        <!-- Paginator - outside of scrollable area -->
        <prehox-paginator
            class="prehox-paginator border-t z-10 bg-white dark:bg-gray-800"
            [pageSizeOptions]="[5, 10, 25, 100]"
            [pageSize]="filtro.limit"
            [length]="totalItems"
            [pageIndex]="filtro.page - 1"
            (page)="pageEvent($event)"
            [showFirstLastButtons]="true"
        ></prehox-paginator>
    </div>

    <!-- Actions -->
    <div class="flex items-center justify-end px-6 py-4 space-x-3 border-t bg-gray-100 dark:bg-black dark:bg-opacity-10">
        <button (click)="clear()" mat-stroked-button [color]="'secondary'" [matDialogClose]="'cancelled'" autoTranslate>Fechar</button>
    </div>
</div>
